import { motion } from "framer-motion";
import FadeIn from "../Animation/FadeIn";

export default function IF_Banner({
    children,
    flexDir = "row",
    src = "/images/kinan-crop.png",
}) {
    const isColumnReverse = flexDir === "column-reverse" || (typeof flexDir === "object" && flexDir.base === "column-reverse");

    return (
        <section className="relative w-full min-h-[60vh] lg:min-h-[70vh] pt-[120px] lg:pt-[140px] pb-[60px] lg:pb-[80px] overflow-hidden flex items-center justify-center">
            {/* Background with Zero Blur / Filter */}
            <div className="absolute inset-0 z-0 overflow-hidden">
                <motion.div
                    initial={{ scale: 1.1, opacity: 0 }}
                    animate={{ scale: 1, opacity: 0.35 }}
                    transition={{ duration: 1.2, ease: "linear" }}
                    className="w-full h-full bg-cover bg-bottom brightness-75"
                    style={{ backgroundImage: "url('/images/bg.jpg')" }}
                />
                <div className="absolute bottom-0 left-0 right-0 h-44 bg-gradient-to-t from-[#08090d] to-transparent" />
            </div>

            {/* Banner Container */}
            <div className="max-w-[1400px] w-full mx-auto relative z-10 px-6 md:px-10">
                <div
                    className={`flex ${isColumnReverse ? "flex-col-reverse lg:flex-row" : "flex-col lg:flex-row"
                        } items-center justify-center gap-8 lg:gap-12`}
                >
                    {/* Portrait Image (Zero Blur, Linear Hover) */}
                    {src && (
                        <div className="shrink-0">
                            <FadeIn direction="right" delay={0.2} duration={0.9}>
                                <div className="relative w-full sm:w-[240px] md:w-[300px] lg:w-[360px] max-w-[70vw] mx-auto">
                                    <motion.div
                                        whileHover={{ scale: 1.02 }}
                                        transition={{ duration: 0.3, ease: "linear" }}
                                    >
                                        <img
                                            src={src}
                                            alt="I-FIT Banner"
                                            className="w-full h-auto block select-none pointer-events-none"
                                            style={{
                                                maskImage: "radial-gradient(ellipse 92% 84% at 50% 40%, black 55%, transparent 96%)",
                                                WebkitMaskImage: "radial-gradient(ellipse 92% 84% at 50% 40%, black 55%, transparent 96%)",
                                            }}
                                        />
                                    </motion.div>
                                </div>
                            </FadeIn>
                        </div>
                    )}

                    {/* Content */}
                    <div className="flex-1 w-full flex flex-col justify-center">
                        {children}
                    </div>
                </div>
            </div>
        </section>
    );
}

export { IF_Banner as IFBanner };
